import { useMemo, Suspense } from 'react';
import { Spinner } from '@comeon/ui';

import { useExecuteContext } from '~/components/payment-beta/deposit/context/execute';

import { ExecuteError, executeDepositViews, SendHandler } from './constants';

const ExecuteStep = () => {
	const { data } = useExecuteContext();
	const { error, actualSendHandler, availableDepositAmount } = data ?? {};

	const view = useMemo(() => {
		if (!error) {
			return (actualSendHandler as SendHandler) ?? ExecuteError.ERROR_SCREEN;
		}

		if (typeof availableDepositAmount !== 'undefined' && availableDepositAmount !== null) {
			return ExecuteError.LUGAS_AMOUNTS_BANNER;
		}

		return ExecuteError.ERROR_SCREEN;
	}, [actualSendHandler, availableDepositAmount, error]);

	const Component = executeDepositViews[view];
	return (
		<Suspense fallback={<Spinner />}>
			<Component />
		</Suspense>
	);
};

export default ExecuteStep;
